import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import FrameCloseBtn from 'src/components/frame-close-btn'
import FrameBackBtn from 'src/components/frame-back-btn'

export class UseCaseDetailsFrame extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    back: PropTypes.func,
    useCase: PropTypes.object.isRequired,
    type: PropTypes.oneOf(['phone', 'browser']),
  }

  static defaultProps = {
    className: '',
    children: null,
    back: () => {},
    type: 'phone',
  }

  get className() {
    const { className, type } = this.props
    return c('im-use-case-details-frame use-case-frame', `${type}-frame`, className)
  }

  render() {
    const { className } = this
    const { children, useCase, back } = this.props
    return (
      <div className={className}>
        <section className="frame-content">
          <FrameCloseBtn />
          <FrameBackBtn onClick={back} />
          <h2 className="frame-heading">{useCase.buttonLabel}</h2>
          <section className="frame-description">{useCase.description}</section>
          <section className="frame-children">{children}</section>
        </section>
      </div>
    )
  }
}

export default connect(state => ({
  property: state.property,
}))(UseCaseDetailsFrame)
